// Module
var code = "<div layout=\"column\" class=\"full-height\"> <bringoz-items-list-display items=\"$ctrl.itemsDisplay\" max-items=\"1\"></bringoz-items-list-display> </div> ";
// Exports
export default code;